(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/inputv2.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/inputv2.trinidad.js'); "use strict";

(() => {

  "use strict";


  var __webpack_require__ = {};





  (() => {

    __webpack_require__.n = module => {
      var getter = module && module.__esModule ?
      () => module['default'] :
      () => module;

      __webpack_require__.d(getter, {
        a: getter
      });


      return getter;
    };

  })();





  (() => {

    __webpack_require__.d = (exports, definition) => {
      for (var key in definition) {
        if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }

      }

    };

  })();





  (() => {
    __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

  })();



  var __webpack_exports__ = {}; 

  __webpack_require__.d(__webpack_exports__, {
    "default": () =>
    inputv2
  });

  ; 

  const external_PropTypes_namespaceObject = window["PropTypes"];

  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);

  ; 

  const external_React_namespaceObject = window["React"];

  var external_React_default = __webpack_require__.n(external_React_namespaceObject);

  ; 

  const external_svs_ui_ReactIcon_namespaceObject = window["svs"]["ui"]["ReactIcon"];

  var external_svs_ui_ReactIcon_default = __webpack_require__.n(external_svs_ui_ReactIcon_namespaceObject);

  ; 

  const _excluded = ["autoCapitalize", "autoComplete", "className", "hasFormData", "id", "inputHelpText", "inverted", "label", "multiline", "selectOnFocus", "prefix", "suffix", "size", "refElem", "isSmall", "showPassword"];

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }





  const Inputv2 = _ref => {
    let {
      autoCapitalize,
      autoComplete,
      className,
      hasFormData,
      id,
      inputHelpText,
      inverted,
      label,
      multiline,
      selectOnFocus,
      prefix,
      suffix,
      size,
      refElem,
      isSmall,
      showPassword
    } = _ref,
        props = _objectWithoutProperties(_ref, _excluded);

    let ariaDescribedBy;
    const inputWrapper = external_React_default().useRef(null);
    const eyeIcon = external_React_default().useRef(null);
    const [showPwd, setPwdVisibility] = external_React_default().useState(showPassword);

    const handleToggle = () => {
      if (showPwd) {
        inputWrapper.current.querySelector('.js-standard-input').type = 'text';
      } else {
        inputWrapper.current.querySelector('.js-standard-input').type = 'password';
      }

      setPwdVisibility(!showPwd);
    };

    const classes = ['input-control'];
    const inputClasses = ['js-standard-input standard-input'];

    const inputProps = _objectSpread(_objectSpread({}, props), selectOnFocus ? {
      onFocus: event => event.target.select()
    } : {});

    if (inverted) {
      classes.push('input-control-inverted');
    } else {
      classes.push('input-control-default');
    }

    if (prefix) {
      inputClasses.push('input-has-prefix');
    }

    if (className) {
      inputClasses.push(className);
      classes.push(className);
    }

    if (multiline) {
      classes.push('input-control-textarea');
    }

    if (inputProps.value) {
      inputClasses.push('input-valid');
    }

    if (!id) {
      ariaDescribedBy = '';
      id = "input-".concat(Math.round(Math.random() * 100000 + 1000));
    } else {
      ariaDescribedBy = "".concat(id, "_desc");
    }

    let inputField;

    if (multiline) {
      inputField = external_React_default().createElement("textarea", _extends({
        "aria-describedby": ariaDescribedBy,
        "aria-label": "".concat(label, ", - ").concat(inputHelpText ? inputHelpText : ''),
        autoCapitalize: autoCapitalize,
        autoComplete: autoComplete,
        className: inputClasses.join(' '),
        cols: inputProps.cols ? inputProps.cols : '1',
        id: id,
        ref: refElem,
        rows: inputProps.rows ? inputProps.rows : '1'
      }, inputProps));
    } else {
      inputField = external_React_default().createElement("input", _extends({
        "aria-describedby": ariaDescribedBy,
        "aria-label": "".concat(label, ", - ").concat(inputHelpText ? inputHelpText : ''),
        autoCapitalize: autoCapitalize,
        autoComplete: autoComplete,
        className: inputClasses.join(' '),
        id: id,
        ref: refElem,
        value: inputProps.value
      }, inputProps));
    }

    const setSuffixWidth = input => {
      input = input.querySelector('.js-standard-input');
      const sufxEl = input.nextElementSibling.querySelector('.input-sufx'); 

      if (input.style.width.length === 0) {
        input.style.width = input.clientWidth > 0 ? "".concat(input.clientWidth - input.nextElementSibling.querySelector('.input-trailing').clientWidth, "px") : "calc(100% - 40px)";
      }

      if (inputProps.type === 'password') {
        sufxEl.style.cursor = 'pointer';
      }
    };

    external_React_default().useEffect(() => {
      if (suffix) {
        setSuffixWidth(inputWrapper.current);
      }
    });

    if (inputProps.type === 'password') {
      suffix = external_React_default().createElement(external_svs_ui_ReactIcon_default(), {
        color: inverted ? 'fc-white' : 'fc-navy',
        icon: showPwd ? 'eye-closed' : 'eye',
        size: "200"
      });
    }

    return external_React_default().createElement("div", {
      className: classes.join(' '),
      ref: inputWrapper
    }, inputField, external_React_default().createElement("div", {
      className: "input-look ".concat(inputProps.disabled ? 'input-look-disabled' : '')
    }, external_React_default().createElement("div", {
      className: "input-leading ".concat(prefix ? 'input-leading-has-prefix' : '')
    }, external_React_default().createElement("div", {
      className: "input-prefx"
    }, prefix)), external_React_default().createElement("div", {
      className: "input-notch"
    }, external_React_default().createElement("div", {
      className: "input-north-notch"
    }, external_React_default().createElement("label", {
      "aria-hidden": "true",
      className: "forms-label js-label-".concat(id, " ").concat(inputProps.value ? 'hide-label' : ''),
      htmlFor: id
    }, external_React_default().createElement("span", {
      className: "original-label"
    }, label), external_React_default().createElement("span", {
      className: "help-text-label"
    }, inputHelpText ? inputHelpText : label))), external_React_default().createElement("div", {
      className: "input-south-notch"
    })), external_React_default().createElement("div", {
      className: "standard-input-middle"
    }), external_React_default().createElement("div", {
      className: "input-trailing",
      onClick: handleToggle,
      ref: eyeIcon
    }, external_React_default().createElement("div", {
      className: "input-sufx"
    }, suffix))));
  };

  Inputv2.propTypes = {
    autoCapitalize: external_PropTypes_default().string,
    autoComplete: external_PropTypes_default().string,
    className: external_PropTypes_default().string,
    hasFormData: external_PropTypes_default().bool,
    id: external_PropTypes_default().string,
    inputHelpText: external_PropTypes_default().string,
    inverted: external_PropTypes_default().bool,
    isSmall: external_PropTypes_default().bool,
    label: external_PropTypes_default().string,
    multiline: external_PropTypes_default().bool,
    prefix: external_PropTypes_default().node,
    refElem: external_PropTypes_default().oneOfType([external_PropTypes_default().object, external_PropTypes_default().func]),
    selectOnFocus: external_PropTypes_default().bool,
    showPassword: external_PropTypes_default().bool,
    size: external_PropTypes_default().string,
    suffix: external_PropTypes_default().node,
    value: external_PropTypes_default().oneOfType([external_PropTypes_default().number, external_PropTypes_default().string]).isRequired
  };
  Inputv2.defaultProps = {
    autoCapitalize: 'off',
    autoComplete: 'on',
    className: '',
    hasFormData: false,
    isSmall: false,
    prefix: null,
    refElem: null,
    selectOnFocus: true,
    showPassword: true,
    suffix: null
  };

  const inputv2 = Inputv2;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Inputv2 = __webpack_exports__.default;
})();
 })(window);